import React from "react";

import { Tab, TabProps } from "@mui/material";
import styled from "@mui/material/styles/styled";
import Tabs, { TabsProps } from "@mui/material/Tabs";

import Stack, { StackProps } from "@rui/Stack";

type WorkspaceModuleProps = StackProps & { fullWidth?: boolean };

export const WorkspaceModule = styled<React.FC<WorkspaceModuleProps>>(
  ({ fullWidth: _fw, ...props }) => <Stack {...props} />
)(({ fullWidth, theme }) => ({
  width: "100%",
  border: "1px solid",
  borderRadius: "8px",
  borderColor: theme.palette.shades.neutral[100],
  [theme.breakpoints.up("lg")]: {
    // 12px = 1/2 the space between modules
    width: fullWidth ? "100%" : "calc(50% - 12px)",
  },
}));

export const WorkspaceModuleTabs = styled((props: TabsProps) => (
  <Tabs variant="scrollable" {...props} />
))(() => ({
  "&.MuiTabs-root": {
    padding: "15px",
    width: "100%",
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
}));

export const WorkspaceModuleTab = styled((props: TabProps) => (
  <Tab {...props} />
))(({ theme }) => ({
  minWidth: "0px",
  marginRight: "10px",
  minHeight: "auto",
  padding: "5px 10px",
  " &.MuiTab-root": {
    width: "fit-content",
    fontFamily: theme.typography.bodySecondaryReg,
    textTransform: "uppercase",
    color: theme.palette.overlay.primary[24],
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.overlay.primary[24],
    borderRadius: "12px",
    color: "white",
  },
}));

export const WorkspaceModuleBody = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 2, 2),
}));
